module.exports = __webpack_public_path__ + "img/metro_greenmarker.c8241294.png";